import { useState} from "react";
import moment from "moment";
import {useSelector} from "react-redux";
import { getBusinessPartnerModel } from "../../BusinessPartner/Infrastructure/BusinessPartner.reducer";
import { makeStyles } from "@mui/styles";
import InputOutlined from "../../DesignSystem/InputOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import FlatIconButton from "../../DesignSystem/FlatButton";
import BasicDatePicker from "../../DesignSystem/BasicDatePicker";
import ModalAlert from "../../DesignSystem/ModalAlert";
import { UserSignUp } from "../../Auth/Infrastructure/Auth.presenter";
import { validateEmail, validatePhone, validateText, validateZipCode} from "../Domain/User.model";
import ValidationCodeModal from "./ValidationCode";
import ModalPassword from "../../DesignSystem/ModalPassword";

const addPhotoIcon = {
  width: "25px",
  height: "25px",
  position: "absolute",
  top: "calc(50% - 12.5px)",
  left: "calc(50% - 12.5px)"
}

const datePickerStyles = {
  maxWidth: "600px",
  width: "100%",
  height: "36px",
  borderRaduis: "5px"
}

const registerBtn = {
  fontSize: "0.875rem",
  border: "2px solid white",
  filter: "drop-shadow(0px 4px 4px rgba(130, 130, 130, 0.25))"
}

const useStyles = makeStyles((theme) => ({
  title:{
    width: "80%",
    fontSize: "3rem",
    lineHeight: "58.09px",
    [theme.breakpoints.down("md")]:{
      textAlign: "center",
      width: "100%"
    },
    [theme.breakpoints.up("md")]:{
      gridColumn: "1/-1"
    }
  },
  formStyles: {
    marginTop: 40,
    width: "100%",
    maxWidth: "780px",
    minHeight: 950,
    margin: "auto",
    position: "relative",
    padding: "20px 20px 30px",
    background: "white",
    borderRadius: 10,
    height: "auto",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    flexDirection: "column",
    gap: 15,
    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      borderRadius: "8px",
      padding: "21px 94px 40px",
      columnGap: 47
    },
  },
  addProfileImage: {
    position: "static",
    width: 131,
    height: 131,
    borderRadius: 5,
    background: "#C4C4C4",
    display: "flex",
    justifyContent: " center",
    alignItems: "center",
    color: "white",
    "&:hover":{
      cursor: "pointer",
      background: "#ABABAB"
    },
    [theme.breakpoints.up("md")]:{
      position: "relative",
      gridColumn: "1/-1"
    },
    [theme.breakpoints.up("lg")]:{
      gridColumn: "1/-1"
    }
  },
  doubleInputContainer: {
    display: "flex",
    height: "auto",
    width: "100%",
    justifyContent: "space-between",
    gap: 10,
    [theme.breakpoints.up("md")]:{
      gap: 47,
      justifyContent: "space-between",
      gridColumn: "1/-1",
    }
  },
  smallInputContainer:{
    [theme.breakpoints.down("md")]:{
      maxWidth: 161,
    }
  },
  inputContainer: {
    width: "100%",
    [theme.breakpoints.up("md")]:{
      maxWidth: 290,
    },
  },
  addresInputContainer:{
    width: "100%",
    [theme.breakpoints.up("md")]:{
      gridColumn: "1/-1"
    }
  },
  labelStyles:{
    fontSize: "1.125rem",
    fontWeight: 500,
    color: "#333333"
  },
  btnContainer:{
    width: "100%",
    display: "flex",
    justifyContent: "center",
    gap: 25,
    [theme.breakpoints.up("md")]:{
      gridColumn: "1/-1",
    }
  },
  inputStyles:{
    width: "100%",
  },
  labelDate: {
    alignSelf: "start",
    fontWeight: 500,
    fontSize: "1.125rem",
    marginBottom: 5,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  photoProfile:{
    borderRadius: 5,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: "10",
    "&:hover":{
      opacity: 0.2,
      cursor: "pointer"
    }
  }
}));

export default function ModalRegisterForm({role, handleAddUser}){
  const userRegisterRole = role === "delivery" ? "deliveryman" : "afiliador";
  const roleUser = () => role === "delivery" ? "repartidor" : "asesor";
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [sending, setSending] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState();
  const businessPartner = useSelector(getBusinessPartnerModel);
  const [isOpenAlert, setOpenAlert] = useState(false);
  const [titleAlert, setTitleAlert] = useState("Ha ocurrido un error");
  const [isError, setError] = useState(false);
  const [response, setResponse] = useState({});
  const [formValues, setFormValues] = useState({
    name: "",
    lastName: "",
    sex: "",
    email: "",
    phone: "",
    address: "",
    zipCode: "",
    city: "",
    state: "",
    photo: "",
    role: userRegisterRole,
    birthDate: moment(new Date()).format("YYYY-MM-DD"),
    zone: ""
  });

  const fieldsValidate = () => {
    const emailResult = validateEmail(formValues.email);
    const nameResult = validateText(formValues.name);
    const lastNameResult = validateText(formValues.lastName);
    const sexResult = formValues.sex !== "";
    const phoneResult = validatePhone(formValues.phone);
    const streetResult = formValues.street !== "";
    const outdoorNumberResult = formValues.outdoorNumber !== "";
    const zipCodeResult = validateZipCode(formValues.zipCode);
    const cityResult = validateText(formValues.city);
    const stateResult = validateText(formValues.state);

    return {emailResult, nameResult, lastNameResult, sexResult, phoneResult, streetResult, outdoorNumberResult, zipCodeResult,cityResult, stateResult}
  }

  const handlePhotoChange = (e) => {
    const allowedExtensions = /(.jpg|.jpeg|.png)$/i;
    if (!allowedExtensions.exec(e.target.files[0].name)) {
      alert("Elige un formato de imagen válido (.jpg, .png, .jpeg)");
    } else {
      setPhoto(e.target.files[0]);
      setPhotoPreview(URL.createObjectURL(e.target.files[0]));
    }
  }; 

  function selectPhoto() {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".png,.jpg,.jpeg";
    fileInput.addEventListener("change", (event) => {
      handlePhotoChange(event);
      //setFormValues({ ...formValues, ['photo']: photo});
    });
    fileInput.click();
    fileInput.remove();
  }

  const showAlertModal = () => setOpenAlert(true);

  const handleClickOpen = (alertState) => {
    setOpenAlert(alertState);
  };

  const handleSubmit =  async (e) => {
    e.preventDefault();
    const valid = fieldsValidate();
    const bsPartnerZone = businessPartner.zone;
    if(valid.nameResult && valid.lastNameResult && valid.sexResult && valid.emailResult && validatePhone && valid.zipCodeResult && valid.cityResult && valid.outdoorNumberResult && valid.streetResult && valid.stateResult){
      setFormValues({...formValues, zone: bsPartnerZone, role: userRegisterRole, photo: photo}) 
      setError(false);
       try {
        setSending(true);
        const {id, temporaryPass} = await UserSignUp({...formValues, role: userRegisterRole, photo: photo, zone: bsPartnerZone});
        setSending(false);
        setResponse({id, temporaryPass});
        setActiveStep(1);
      } catch (error) {
        setError(true);
        setSending(false);
        setTitleAlert(error.message);
        showAlertModal();
      }
    }else{
      setSending(false);
      setError(true);
      setTitleAlert("Ingresa los datos correctamente");
      showAlertModal();
    }
  }

  const getInputValue = (key, value) => {
    setFormValues({ ...formValues, [key]: value});
  };

  const getDatePickerValue = (date) =>{
    const formatedDate = moment(new Date(date)).format("YYYY-MM-DD");
    setFormValues({...formValues, birthDate: formatedDate})
  }

  const handleValidationCodeSubmit = () => {
    setActiveStep(2);
  }

  const handleRegistration = () => {
    handleAddUser(true);
  }

  return (
    <>
      {activeStep === 0 &&
      <>    
      <form className={classes.formStyles}>
        <h4 className={classes.title}>Agregar {roleUser()}</h4>
        <div className={classes.addProfileImage} onClick={selectPhoto}>
          <AddCircleOutlineOutlinedIcon sx={addPhotoIcon}/>
          {photoPreview && <img className={classes.photoProfile} src={photoPreview} alt="foto de perfil"/>}
        </div>
        <InputOutlined labelTitle={`Nombre del ${roleUser()}`} placeholderText="Nombre(s)" name="name" handleInputChange={getInputValue}/>
        <InputOutlined labelTitle="Apellido" placeholderText="Apellido" name="lastName" handleInputChange={getInputValue}/>
        <div className={classes.doubleInputContainer}>
          <div className={classes.inputStyles}>
            <p className={classes.labelDate}>Fecha de nacimiento</p>
            <BasicDatePicker customStyles={datePickerStyles} variant="outlined" handleChange={getDatePickerValue}/>
          </div>
          <InputOutlined labelTitle="Sexo" placeholderText="" name="sex" handleInputChange={getInputValue}/>
        </div>
        <InputOutlined labelTitle="Correo electrónico" placeholderText="correo@example.com" name="email" handleInputChange={getInputValue} handleValidate={validateEmail}/>
        <InputOutlined labelTitle="Teléfono" placeholderText="" name="phone" handleInputChange={getInputValue}/>
        <div className={classes.doubleInputContainer}>
          <InputOutlined labelTitle="Calle" placeholderText="" name="street" handleInputChange={getInputValue}/>
          <InputOutlined labelTitle="Núm. exterior" placeholderText="" name="outdoorNumber" handleInputChange={getInputValue}/>
        </div>
        <InputOutlined labelTitle="Código postal" placeholderText="" name="zipCode" handleInputChange={getInputValue}/>
        <InputOutlined labelTitle="Ciudad" placeholderText="" name="city" handleInputChange={getInputValue}/>
        <InputOutlined labelTitle="Estado" placeholderText="" name="state" handleInputChange={getInputValue}/>
        <div className={classes.btnContainer}>
          <FlatIconButton isDisable={sending} widthBtn="290px" typeButton="submit" title={sending ? "Enviando..." : "Registrar"} onClick={handleSubmit} customStyles={registerBtn}/>
        </div>
      </form>
      </>
      }
      {activeStep === 1 && <ValidationCodeModal data={formValues} codeSubmit={handleValidationCodeSubmit} id={response.id || ""}/>}
      {activeStep === 2 && <ModalPassword passwordSubmit={handleRegistration} tempPw={response.temporaryPass || ""}/>}
      <ModalAlert title={titleAlert} typeAlert={isError ? "error" : "success"} isOpen={isOpenAlert} handleAlert={handleClickOpen}/>
    </>
  );
}